<!-- Facebook general search results (mobile) -->
<a class="fgs" [attr.href]="data.url || null" target="_blank" rel="noopener noreferrer">
  <app-meta-creative class="fgs-image" [src]="data.creative" [kind]="data.creativeKind" slot="cover"></app-meta-creative>
  <div class="fgs-copy">
    <div class="fgs-page">
      <img class="fgs-avatar" [src]="avatar" alt="" />
      <span class="fgs-name">{{ pageName }}</span>
      <i class="bi bi-patch-check-fill fgs-verified"></i>
      <span class="fgs-label">Sponzorirano</span>
      <i class="bi bi-three-dots fgs-menu"></i>
    </div>
    <div class="fgs-text">{{ primaryText.text }}</div>
    <div class="fgs-more" *ngIf="primaryText.truncated">...</div>
  </div>
</a>
